export enum AgreementTypes {
  Quotation = 1,
  Policy = 2,
}
